import { connect } from 'react-redux'
// import React from 'react'
// import PropTypes from 'prop-types'
import R from 'ramda'
import { PAGES } from '../../constants'

import {
  getPageData
} from '_utils'

import {
  setNavigation
} from '_actions'

import {
  // create,
  refresh,
  patch,
  remove,
  deactivate,

  addNote,
  removeNote,

  fetchAutocompleteSuggestions,
  setAutocompleteSelections,
  clearAutocompleteSuggestions,
  refreshList,

  activationCodesStatePath,
  activationCodesRefreshList,
  activationCodesUpgrade,
  activationCodesDeactivate
} from '_actions/resellers'

import Resellers from './page'

const mapStateToProps = state => ({
  resellersPage: R.pathOr({}, ['pages', PAGES.RESELLERS], state),
  getAcData: (resellerId) => getPageData(activationCodesStatePath(resellerId), state)
})

const mapDispatchToProps = dispatch => ({
  // reseller actions
  onRefreshReseller: R.compose(dispatch, refresh), // ({resellerId})
  onRemoveReseller: R.compose(dispatch, remove), // ({resellerId, pageNum, perPage})
  onDeactivateReseller: R.compose(dispatch, deactivate), // ({resellerId})
  onModifyOne: R.compose(dispatch, patch), // ({resellerId, payload})
  // notes actions
  onAddNote: R.compose(dispatch, addNote), // ({resellerId, payload})
  onRemoveNote: R.compose(dispatch, removeNote), // ({resellerId, noteId})
  goToPage: R.compose(dispatch, setNavigation, R.merge(R.__, {pageName: PAGES.RESELLERS})), // navigation
  onRefreshList: R.compose(dispatch, refreshList), // navigation, aka R.pathOr({}, ['pages', PAGES.RESELLERS, 'navigation'], this.props.state)
  onCreateReseller: R.ifElse(
    reseller => (reseller && reseller._id),
    R.compose(dispatch, setNavigation, reseller => ({pageName: PAGES.RESELLERS, ids: [reseller._id]})),
    () => dispatch({type: 'noaction'})
  ),
  // main inst autocomplete
  onTermChange: R.compose(dispatch, fetchAutocompleteSuggestions), // {term, pageNum}
  onSelectionChange: R.compose(dispatch, setAutocompleteSelections), // selections
  onClearSuggestions: R.compose(dispatch, clearAutocompleteSuggestions), // selections
  // reselleral Activation codes
  acFuncs: {
    onRefreshOwner: R.compose(dispatch, refresh), // ({resellerId})
    onRefreshReseller: R.compose(dispatch, refresh), // ({resellerId})
    onUpgradeAc: R.compose(dispatch, activationCodesUpgrade), // ({resellerId, licenseId})
    onDeactivateAc: R.compose(dispatch, activationCodesDeactivate), // ({resellerId, licenseId})
    setNavigation: R.compose(dispatch, setNavigation),
    goToPage: R.compose(dispatch, activationCodesRefreshList) // { resellerId, pageNum, perPage, ids, showExpired, filter }
  }
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Resellers)



// WEBPACK FOOTER //
// ./webAdmin/components/resellers/index.js